import { AxiosInstance } from "axios";
import { Method, Resource } from "../Resource";

type CountryRisk = {
  risk?: string;
  country?: string | null;
  breakdown?: object | null;
};

type PoliticalExposureRisk = {
  risk?: string;
  checkId?: string | null;
};

type OccupationRisk = {
  risk?: string;
  checkId?: string | null;
  occupationCategory?: string | null;
  occupationTitle?: string | null;
};

type WatchlistRisk = {
  risk?: string;
  checkId?: string | null;
};

export type RiskProfile = {
  overall?: string;
  checkId?: string;
  countryRisk?: CountryRisk;
  politicalExposureRisk?: PoliticalExposureRisk;
  occupationRisk?: OccupationRisk;
  watchlistRisk?: WatchlistRisk;
  updatedAt?: string;
};

export class RiskProfiles extends Resource<RiskProfile> {
  constructor(axiosInstance: AxiosInstance) {
    super("clients", axiosInstance);
  }

  public async get(clientId: string): Promise<RiskProfile> {
    return this.request({
      method: Method.GET,
      path: `${clientId}/riskProfile`
    });
  }
}
